/**
    红包
**/
<template>
  <div style="width: 1200px;
    margin: 30px auto;">
    <div class="wholeBox" v-loading="loading">
        <div class="infoBox">
            <span>收货地址 <el-divider direction="vertical"></el-divider> 大型商品下单后，收货地址将无法修改。</span>
            <span class="textRedColor">快递公司会电话联系您确认送货时间，收货时需核对身份证信息。</span>
        </div>
        <div class="getaddressList">
            <el-row>
                    <div @click="selectedAddress(index+1,item.said)" v-for="(item,index) in addressLists" :key="item.said" :class="isSelectedAddress==index+1?'isActive getaddressItem':'getaddressItem'">
                        <el-col >
                            <p><strong>姓名: </strong> {{item.recipient}}</p>
                            <p><strong>电话: </strong> {{item.phoneNumber}}</p>
                            <p><strong>地址: </strong> {{item.areaName}} <span style="margin-left: 35px;">{{item.address}}</span></p>
                            <p><strong>邮编: </strong> {{item.postalCode}}</p>
                            <div class="addressColor">
                                <span @click="editAddress(item)" class="edit">修改</span>
                                <!-- <span @click="deleteAddress(item.said)" class="delete">删除</span> -->
                                <el-popconfirm
                                    confirm-button-text='确定'
                                    cancel-button-text='取消'
                                    confirm-button-type='danger'
                                    @confirm="deleteAddress(item.said)"
                                    icon="el-icon-info"
                                    icon-color="red"
                                    title="确定要删除吗？"
                                    placement='top'
                                    class="delete"
                                    >
                                    <el-button slot="reference">删除</el-button>
                                    </el-popconfirm>
                            </div>
                        </el-col>
                    </div>
                    <el-col >
                        <div class="getaddressItem addHover" @click="addAddress()">
                            <div class="el-icon-circle-plus addIcon"></div>
                            <p style="text-align: center;">添加地址</p>
                        </div>
                    </el-col>
            </el-row>
            
        </div>
    </div>
    <div class="orderBox">
        <el-row class="payMethods">
            <el-col :span="4">支付方式</el-col>
            <el-col :span="20">
                <el-radio-group v-model="payMethodsCheckbox">
                    <el-radio-button label="1">在线支付</el-radio-button>
                    <el-radio-button label="2">货到付款</el-radio-button>
                </el-radio-group>
            </el-col>           
        </el-row>
        <el-row class="payMethods">
            <el-col :span="4">发票</el-col>
            <el-col :span="20">
                <el-radio-group v-model="openradio">
                    <el-radio :label="1">不开发票</el-radio>
                    <el-radio :label="2">开发票</el-radio>
                </el-radio-group>
            </el-col>           
        </el-row>
        <div class="orderDetailText">
            <span>订单详情</span>
            <router-link to="/shoppingcart">返回购物车 ></router-link>
        </div>
        <el-row class="order_detailInfo">
            <div v-for="(shop,index) in selectedOrderList" :key='index'>
                <el-col :span="24">
                    <el-col :span="24" style="margin: 10px 0;">{{shop.name}}</el-col> 
                </el-col>
                <div v-for="(items,index) in shop.goods" :key='index'>
                    <el-row class="order_Info">
                        <el-col :span="1"> <el-image :src="`${items.photos}`"></el-image></el-col> 
                        <el-col :span="15" class="order_Info_item OneLineDisplay"><span style="cursor: pointer;" @click="$router.push(`/goodsDetail_supplie?id=${items.id}`)">{{ items.name }} {{items.specificationlist[0].name}}</span></el-col>
                        <!-- <el-col :span="6" class="order_Info_item" style="padding-left: 20px;">({{items.marketprice}}元 + 0.00积分) x {{items.number}}</el-col>            -->
                        <el-col :span="6" class="order_Info_item" style="padding-left: 20px;">({{items.realprice}}元 + 0.00积分) x {{items.number}}</el-col>           
                        <el-col :span="2" class="order_Info_item">有货</el-col>           
                    </el-row>
                    <!-- marketprice 需要乘以折扣 -->
                    <!-- <el-row :span="24" class="order_detailInfo_price"><el-col>{{items.marketprice}}元</el-col></el-row>       -->
                    <el-row :span="24" class="order_detailInfo_price"><el-col>{{items.realprice * items.number}}元</el-col></el-row>      
                </div>   
                <el-row class="Fee_Dtails">
                    <el-col :span="16" class="Fee_Dtails_add">
                        <el-popover
                            placement="/bottom-end"
                            width="600"
                            trigger="click">    
                            <div class="use_red">
                                <p>选择红包</p>
                            <div> 您暂时没有可用的红包</div>
                                <el-button slot="reference">确定</el-button>
                            </div>
                            <el-button slot="reference"><i class="el-icon-circle-plus"></i> 使用红包</el-button>
                        </el-popover>
                    </el-col>   
                    <el-col :span="8" class="Fee_Dtails_info">
                        <el-row class="Fee_Dtails_item">
                            <el-col :span="24" class="order_Info_item OneLineDisplay">商品数量：</el-col>           
                            <el-col :span="24" class="order_Info_item">金额合计：</el-col>           
                            <el-col :span="24" class="order_Info_item">会员折扣：</el-col>  
                            <el-col :span="24" class="order_Info_item">活动优惠：</el-col>  
                            <el-col :span="24" class="order_Info_item">红包抵扣：</el-col>  
                            <el-col :span="24" class="order_Info_item">运费：</el-col>  
                            <el-col :span="24" class="order_Info_item">总金额：</el-col> 
                        </el-row>
                        <el-row class="Fee_Dtails_money">
                            <el-col :span="24" class="order_Info_item OneLineDisplay">{{totalNum(shop.goods)}}</el-col>           
                            <el-col :span="24" class="order_Info_item">{{sumPrice(shop.goods)}}</el-col>           
                            <el-col :span="24" class="order_Info_item">{{0}}元</el-col>  
                            <el-col :span="24" class="order_Info_item">-{{0}}元</el-col>  
                            <el-col :span="24" class="order_Info_item">{{0}}元</el-col>  
                            <el-col :span="24" class="order_Info_item">{{0}}元</el-col>  
                            <el-col :span="24" class="order_Info_item">{{totalPrice(shop.goods)}}元</el-col> 
                        </el-row>
                    </el-col>
                </el-row>
                      
            </div>
            <div class="nodate" v-if="selectedOrderList.length==0?true:false">
                 暂无数据 ！
            </div>
        </el-row>
        <el-row class="total_price">
            <el-col :span="21">
                应付总金额：
            </el-col>
            <el-col :span="3">
                <span class="total_price_color">{{payMoney()}}</span> 元
            </el-col>    
        </el-row>
        <div v-show="!selected" style="text-align:right"><el-button type="primary" class="buttonBgd" @click="gotoAcount()">去结算</el-button></div>
        <div v-show="selected" style="text-align:right"><el-button type="primary" @click="orderNow()" class="buttonBgd">立即下单</el-button></div>
    </div>


    <!-- 点击领取后的弹框 -->
    <el-dialog
        :visible.sync="dialogVisible"
        :destroy-on-close='true'
        :close-on-click-modal="false"
        @close ='beforeClose' 
        width="30%"
        class="dialogBox">
        <div class="textCenter">编辑基础资料</div>
        <span slot="footer" class="dialog-footer">
            <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
             
                <el-form-item label="收件人" prop="recipient">
                    <el-input type="text" v-model="ruleForm.recipient" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="phoneNumber">
                    <el-input type="text" v-model="ruleForm.phoneNumber" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="地址" prop="areaid">
                    <!-- <el-input type="text" v-model="ruleForm.areaid" autocomplete="off"></el-input> -->
                    <el-cascader
                        v-model="cascaderAreaValue"
                        ref="cascaderAddr"
                        class="cascaderArea"
                        placeholder="收货地址"
                        :props="{ checkStrictly: true }"
                        :options="getprovince"
                        @change="areaHandleChange">
                    </el-cascader> 
                </el-form-item>
                <el-form-item label="详细地址" prop="address">
                    <el-input v-model.number="ruleForm.address"></el-input>
                </el-form-item>
                <el-form-item label="邮政编码" prop="postalCode">
                    <el-input v-model.number="ruleForm.postalCode"></el-input>
                </el-form-item>
                <el-form-item prop="">
                    <el-checkbox v-model="ruleForm.defaultAddress">默认地址</el-checkbox>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary"  v-show="showEditButtom?false:true" @click="submintAddress()" class="buttonBgd">确 定</el-button>
                    <el-button type="primary" v-show="showEditButtom?true:false" @click="submintAddress('edit')" class="buttonBgd">确 定 修 改</el-button>
                </el-form-item>
                </el-form>
        </span>
    </el-dialog>
  </div>
</template>
<script>
import {mapState,mapMutations} from 'vuex'
import { addresslist,address_add,address_remove,address_saveedit,addOrder,area_list  } from '@/api/xunyou'
export default {
  data() {
    return {
        userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
        isSelectedAddress:'',        
        loading:false,
        showEditButtom:false,
        dialogVisible:false,        
        selected:false,
        openradio:1,
        cascaderAreaValue:[],
        ruleForm:{
            muid:JSON.parse(localStorage.getItem("userdata")).userId,
            recipient:'',
            phoneNumber:'',
            areaid:'',
            address:'',
            postalCode:'',
            defaultAddress:1,
        },
        getprovince:[], // 地址联动
        rules:{
            recipient: [{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
            phoneNumber: [{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
            areaid: [{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
            address: [{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
            postalCode: [{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
        },
        addressLists:[],        
        selectedOrderList: JSON.parse(sessionStorage.getItem("selectList")) || [],
        scidArr:[],
        numberTotal:0,
        orderTitle:'', 
        moneyTotal: 0, // 应付总额
        priceList:[], // 各个店铺总金额
        payMethodsCheckbox: 1, // 支付方式 在线支付/货到付款
        shopGoodsObj:[], // 店铺及其商品对应的集合
        selectedAddressId:'', // 选择的收货地址id
    };
  },
  // 注册组件
  components: {},
   computed:{
    ...mapState(['getprovince'])
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {},
  mounted(){   
      this.getaddresslist()
    //   this.getprovinceList()
    //   let shopGoodsObj = [] // 店铺及其商品对应的集合
    console.log(this.selectedOrderList,'携带过来的参数')
      this.selectedOrderList.forEach((shop)=>{
          let obj = {};
          let goodList = [];
            this.scidArr=[]
            let mid = '';
        shop.goods.forEach((item)=>{
             let child ={
               id: item.id,
               number:item.number,
               realprice:item.realprice,
               bxysid:item.specificationlist[0].bXySid
             }
             mid = item.mid
             this.scidArr.push(item.scid)
             goodList.push(child)
          })
          obj = {
                bxmId:mid,
                title:shop.goods[0].name, // 订单标题
                amount:this.payMoney(), // 应付总金额
                said:this.selectedAddressId,   // 收货id
                type:this.payMethodsCheckbox,//支付方式
                redPay:'', // 红包折扣
                discountOffer:'', // 折扣优惠
                goodsList:goodList
          }
           this.shopGoodsObj.push(obj) 
        //   shopGoodsObj.id = 
        //   newbxmIdArr.push(shop.bxmId);
        //   
        })
    //   this.bxmIdArr =  newbxmIdArr.toString()
    //   this.goodsIdArr =  newgoodsIdArr.toString()
    //    console.log(this.shopGoodsObj,'嗲过来的数据')
      
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
      //   选择收货地址
        selectedAddress(index,selectedAddressId){
            this.selected = true;
            this.isSelectedAddress = index;
            this.selectedAddressId = selectedAddressId
            console.log(this.selectedAddressId,'选择的id')
        },

        //  // 获取省地址
        //     getprovinceList(){
        //         area_list()
        //             .then(res => {
        //             if (res.code == 0) {
        //                 this.getprovince = res.data;
        //             } else {
        //                 this.$message({
        //                 type: 'info',
        //                 message: res.msg
        //                 })
        //             }
        //             })
        //             .catch(err => {
        //             this.editFormVisible = false
        //             this.loading = false
        //             this.$message.error('获取地址失败，请稍后再试！')
        //             })
        //     },
            // 填写地址选择
            areaHandleChange(value){
                this.$refs['cascaderAddr'].getCheckedNodes()
                this.ruleForm.areaid = value[value.length-1]
                console.log(this.cascaderAreaValue,'填写地址选择');
            },

      //  计算店铺商品数量
       totalNum(data){
           let total = data.reduce((sum, item) => {
                return sum + item.number; // 隐式转换 
            }, 0);
            return total;
       },
    //   计算店铺金额合计
     sumPrice(data){
        let sumPrice = data.reduce((sum, item) => {
              return sum + item.number * item.realprice; // 隐式转换 <!-- marketprice 需要乘以折扣 -->
          }, 0);
          return sumPrice;
     }, 
    //   计算店铺总金额
     totalPrice(data,num = 0){
         this.priceList = [];
         let totalPrice = this.sumPrice(data) - num;
        //  this.priceList.push(totalPrice)
        console.log(totalPrice)
         return totalPrice;
     }, 

    //   应付金额
        payMoney(){
            let payMoney = 0;
            this.selectedOrderList.forEach((shop)=>{
            payMoney +=this.totalPrice(shop.goods);
            })
            return payMoney;
        }, 
    // dealDates(){
    //   let selectList =  JSON.parse(sessionStorage.getItem("selectList"))
    //   selectList.forEach((item)=>{
    //       this.numberTotal+=item.goods.number
    //   })
    //       console.log(this.numberTotal,'遍历1111111111111');
    // },
      // 立即领取红包
      addAddress(){
          this.dialogVisible= true
      },
    //   关闭弹框清空
      beforeClose(){
          this.ruleForm = {}
      },
    //   新增收货地址
      submintAddress(item){
        //   console.log(editReq,'xiugai1')
          if(item == 'edit'){             
              this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                     let editReq = {
                        muid:this.ruleForm.muid,
                        said:this.ruleForm.said,
                        recipient:this.ruleForm.recipient ,
                        phoneNumber:this.ruleForm.phoneNumber ,
                        areaid:this.ruleForm.areaid ,
                        address:this.ruleForm.address,
                        postalCode:this.ruleForm.postalCode ,
                        defaultAddress:this.ruleForm.defaultAddress?1:0
                    }
                    address_saveedit(editReq)
                        .then(res => {
                        if (res.code == 0) {
                            this.showEditButtom = false
                            this.dialogVisible= false
                            this.ruleForm = {}
                            this.getaddresslist()
                        } else {
                            this.$message({
                            type: 'info',
                            message: res.msg
                            })
                        }
                        })
                        .catch(err => {
                        this.dialogVisible= false
                        this.$message.error('修改失败，请稍后再试！')
                        })
                    } 
                });
          }else{
              this.$refs.ruleForm.validate((valid) => {
                  this.ruleForm.muid = this.userInfo.userId
                   this.ruleForm.defaultAddress=this.ruleForm.defaultAddress?1:0
                if (valid) {
                    address_add(this.ruleForm)
                        .then(res => {
                        if (res.code == 0) {
                            this.dialogVisible= false
                            this.ruleForm = {}
                            this.getaddresslist()
                        } else {
                            this.$message({
                            type: 'info',
                            message: res.msg
                            })
                        }
                        })
                        .catch(err => {
                        this.dialogVisible= false
                        this.$message.error('提交失败，请稍后再试！')
                        })
                    } 
                });
          }
      },

    //   删除地址
    deleteAddress(deleteId){
        address_remove({ids:deleteId})
            .then(res => {
              if (res.code == 0) {
                  this.getaddresslist()
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.$message.error('删除失败，请稍后再试！')
            })
    },
    // 修改地址
    editAddress(item){
        this.dialogVisible = true
        this.showEditButtom = true
        this.ruleForm = {
            muid:item.muid,
            said :item.said,
            recipient:item.recipient,
            phoneNumber:item.phoneNumber,
            areaid:item.areaid,
            address:item.address,
            postalCode:item.postalCode,
            defaultAddress:item.defaultAddress==1?true:false,
        }
    },
    // 地址查询
      getaddresslist() {
          this.loading = true
         addresslist({muid:this.userInfo.userId})
            .then(res => {
              if (res.code == 0) {
                  this.loading = false
                  this.addressLists = res.rows
                //   this.envelopeList = res.rows;
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('查询收货失败，请稍后再试！')
            })
    },

    // 显示 去下单 的按钮说明没有选择地址
    gotoAcount(){
        this.$message({
              type: 'info',
              message: '请选择地址'
            })
        return
    },
    orderNow(){
        if(this.selectedOrderList.length==0){
             this.$message({
                  type: 'info',
                  message: '暂无下单商品信息,请前去商场挑选商品'
                })
            return
        }      
        this.shopGoodsObj[0].said = this.selectedAddressId   
        const req ={
            muid:this.userInfo.userId, //买家ID
            shopInfo:this.shopGoodsObj,//店铺ID及其商品集合 
            scid:this.scidArr.toString(),         
        }
         addOrder(req)
            .then(res => {
              if (res.data.code == 0) {
                  sessionStorage.removeItem("selectList")
                  sessionStorage.setItem("account", JSON.stringify(this.payMoney()));  // 金额后期删除此处
                  console.log(res.data.data,'xiadan')
                  sessionStorage.setItem("orderGoodsInfo", JSON.stringify(res.data.data)); 
                   this.$message({
                    type: 'success',
                    message: res.data.msg
                    })
                    this.$router.push('/orderNow');
              } else {
                this.$message({
                  type: 'info',
                  message: res.data.msg
                })
              }
            })
            .catch(err => {
              this.$message.error('查询收货失败，请稍后再试！')
            })
        // this.$router.push('/orderNow');
    }
  },
};
</script>

<style scoped lang="less">
.wholeBox{
    padding:30px;
    background: white;
    .isActive{
        border: 1px solid #ff6700 !important;
        background: #f1f6fd;
    }
    .infoBox{
        .textRedColor{
            color:#ff6700;
        }
    }
    .getaddressList{
        margin: 20px 0;
        display: flex;
        justify-content: flex-start;
        .addHover:hover{
            cursor: pointer;
            color:#ff6700;
        }
        .getaddressItem{
            border: 1px solid #ccc;
            display: inline-block;
            padding: 30px;
            box-sizing: border-box;
            margin-right: 20px;
            width: 220px;
            .addIcon{
                font-size: 30px;
                text-align: center;
                display: block;
                margin-bottom: 10px;
                margin-top: 15px;
            }
            p{
                line-height: 25px;
            }
            .addressColor{
                text-align: right;
                position: relative;
                bottom: -20px;
                color: #ff6700;
                cursor: pointer;
                font-size: 14px;
                span{
                    display: inline-block;
                    margin-left: 15px;
                }
                .delete{
                    /deep/button.el-button.el-button--default.el-popover__reference {
                        border: 0px;
                        color: #ff6700;
                        padding: 0;
                    }
                    /deep/.el-button:focus, .el-button:hover{
                        background: transparent;
                    }

                }
            }
        }
    }   
    
}
.orderBox{
    padding: 0 27px;
    background: white;
    .payMethods{
        padding: 30px !important;
        background: white !important;
        border-bottom: 1px solid #ccc !important;        
        /deep/.el-radio-button__orig-radio:checked+.el-radio-button__inner {
            border-color: #ff6700;
            color: #ff6700;
            background: transparent;
        }
    }
/deep/.el-row.payMethods {
            line-height: 40px;
            font-size: 18px;
        }
    .orderDetailText {
        display: flex;
        justify-content: space-between;
        padding: 40px 0px 5px 27px;
        background: white;
        font-size: 18px;
        a{
            color: #b0b0b0;
        }
    }
    .order_Info{
        font-size: 14px;
        .el-image{
            height: 30px;
            width: 30px;
        }
        .order_Info_item{
            line-height: 30px;
        }
    }
    .order_detailInfo{
        padding: 10px 27px;
        // border-bottom: 1px solid #ccc;
        border-top: 1px solid #ccc;
        font-size: 14px;
        background: white;
        .nodate {
            text-align: center;
            margin: 70px;
            font-size: 16px;
        }
        .order_detailInfo_price{
            padding: 0 60px;
            color: #ff6700;
        }
    }
    .Fee_Dtails{
        font-size: 14px;
        padding: 27px 0 27px 27px;
        background: white;
        border-top: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        .Fee_Dtails_add{
            i.el-icon-circle-plus {
                color: #ff9a00;
                font-size: 30px;
                vertical-align: middle;
                cursor: pointer;
            }
            .use_red{
               text-align: center; 
               p{
                   font-size: 18px;
                   color: #757575;
                   text-align: left; 
                   padding: 0 20px;
                   box-sizing: border-box;
               }
               div {
                   height: 180px;
                   line-height: 180px;
               }
            }
        }
        .order_Info_item{
            line-height: 30px;
            color: #757575;
        } 
        .Fee_Dtails_money{
            text-align: right;
            .order_Info_item{
                color: #ff6700 !important;
            }
        }
        .Fee_Dtails_info{
            display: flex;
            .Fee_Dtails_item.el-row {
                text-align: right;
            }
        }
               
    }
    .order_detailInfo .Fee_Dtails:last-child{
        border-bottom: 0px;
    }
    .total_price{
        font-size: 25px;
        text-align: right;
        margin: 20px 0 20px 0;
        // border-bottom: 1px solid #ccc;
        background: white;
        .total_price_color{
            color: #ff6700;
            font-weight: bold;
        }
    }
   
}
 button.el-button.buttonBgd.el-button--primary {
        background-color: #ff6700;
        border-color: #ff6700;
        font-size: 18px;
        margin-bottom: 20px;
    }
.cascaderArea.el-cascader {
    width: 100%;
    /deep/input[disabled], /deep/input[disabled="disabled"], /deep/input[readonly], /deep/input[readonly="readonly"] {
    background-color: white;
}
}
 
</style>

 
 

 


// WEBPACK FOOTER //
// src/views_supplier/shoppingcart/orderDetail.vue